import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/service/common.service';
import { VoiceAssistantService } from 'src/app/shared/service/voiceAssistantService.service';

@Component({
  selector: 'app-interview-ai-view',
  templateUrl: './interview-ai-view.component.html',
  styleUrls: ['./interview-ai-view.component.scss'],
  standalone :false
})

export class InterviewAiViewComponent implements AfterViewInit {
  @Input() size: 'big' | 'small' = 'big';
  agentSpeakingState: boolean = false;
  isExpDrive: boolean = false;

  constructor(private voiceAssistantService: VoiceAssistantService, public commonService: CommonService) {
    const storedIsExpDrive = sessionStorage.getItem('isExpDrive');
    if (storedIsExpDrive && storedIsExpDrive !== 'undefined') {
      try {
        this.isExpDrive = !!JSON.parse(storedIsExpDrive);
      } catch {
        this.isExpDrive = storedIsExpDrive === 'true';
      }
    }
  }
  

  
  isAssistantSpeaking$!: Subscription
  @ViewChild('bgVideoRef') bgVideoRef!: ElementRef<HTMLVideoElement>;

  ngAfterViewInit() {
    this.isAssistantSpeaking$ = this.voiceAssistantService.isAssistantSpeaking$.subscribe((isAssistantSpeaking) => {
      this.agentSpeakingState = isAssistantSpeaking;
    });
    if (this.bgVideoRef?.nativeElement) {
      this.bgVideoRef.nativeElement.playbackRate = 0.8;
    }
  }

  get isSizeSmall(): boolean {
    return this.size === 'small';
  }
}
